import React from 'react';
import { Box, Typography, Paper, Stack, alpha, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IClassNotificationStats } from 'services/SchoolClass/types';

interface NotificationSummaryCardProps {
  stats?: IClassNotificationStats;
  isLoading: boolean;
}

export const NotificationSummaryCard = React.memo(function NotificationSummaryCard({ stats, isLoading }: NotificationSummaryCardProps) {
  const navigate = useNavigate();

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Typography variant="body2" color="text.secondary" fontWeight="bold" sx={{ mb: 1 }}>
        Notificações aos Pais (Últimos 7 dias):
      </Typography>
      
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={24} /></Box>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h3" fontWeight="bold" color="text.primary">{stats?.totalSent || 0}</Typography>
            <Typography variant="caption" color="text.secondary">Total de envios</Typography>
          </Box>
          
          <Stack spacing={0.5} sx={{ minWidth: 140 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: (theme) => alpha(theme.palette.success.main, 0.1), px: 1, py: 0.5, borderRadius: 1 }}>
              <Typography variant="caption" color="success.main">● Entregues:</Typography>
              <Typography variant="caption" color="success.main" fontWeight="bold">{stats?.successCount || 0}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: (theme) => alpha(theme.palette.error.main, 0.1), px: 1, py: 0.5, borderRadius: 1 }}>
              <Typography variant="caption" color="error.main">● Falhas:</Typography>
              <Typography variant="caption" color="error.main" fontWeight="bold">{stats?.errorCount || 0}</Typography>
            </Box>
          </Stack>
        </Box>
      )}
      
      <Typography 
        onClick={() => navigate('/app/notification-logs')}
        variant="caption" 
        color="primary.main" 
        sx={{ display: 'block', textAlign: 'center', mt: 2, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
      >
        Ver Auditoria de Envios
      </Typography>
    </Paper>
  );
});